/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsQuotationSurchargeInfoResponseDto>
>;
export function request(
  params: API.tms.logisticsQuotationSurchargeInfo.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotationSurchargeInfo/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
